// @flow

// Utils
import traverse from 'fc-utils/traverse'

// Types
import type {
  DataTableState,
} from 'fc-component-datatable/types'

// Constants
import {
  TREE,
  TABLE_BRANCH,
} from '../constants'

export default (traverse([TREE, TABLE_BRANCH]): Selector$<DataTableState>)
